import { render } from "./MelatiCounter.vue?vue&type=template&id=297bd877&scoped=true&ts=true"
import script from "./MelatiCounter.vue?vue&type=script&lang=ts"
export * from "./MelatiCounter.vue?vue&type=script&lang=ts"

import "./MelatiCounter.vue?vue&type=style&index=0&id=297bd877&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297bd877"]])

export default __exports__